import { render } from "./MakeQuoteUpload.vue?vue&type=template&id=2f7f8098&scoped=true"
import script from "./MakeQuoteUpload.vue?vue&type=script&lang=js"
export * from "./MakeQuoteUpload.vue?vue&type=script&lang=js"

import "./MakeQuoteUpload.vue?vue&type=style&index=0&id=2f7f8098&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f7f8098"]])

export default __exports__